import {CompetitorStatsPageRouteMetaDataModel} from "./competitor.stats-page.route.meta-data.model";
import {PAGES} from "../../../../../core/consts";
import {CompetitorPageRouteConfig} from "../../../models/competitor.page-route.config";

export class CompetitorStatsPageRouteConfig extends CompetitorPageRouteConfig {
  static injectables = [];

  constructor() {
    super({
      name: PAGES.COMPETITOR.stats,
      path: 'stats',
      componentImport: () => import("../components/competitor.stats-page" /* webpackChunkName: "competitor.stats-page" */),
      metadataType: CompetitorStatsPageRouteMetaDataModel
    });
  }
}
